
var $ = require('js/sw-jquery/sw-jquery');

/**
 * Polling instance container is a view
 * that will register and display new
 * polling instances as they are created
 *
 * @param $fragment
 */
module.exports = function($fragment) {

  $fragment.swFindWithSelf('[data-sw-polling-instance-container]').each(function() {

    var $el = $(this);
    require(['js/lib/views/PollingInstanceContainer'], function(PollingInstanceContainer) {

      new PollingInstanceContainer({
        el: $el
      });

    });

  });


};
